








































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import CommonMixin from "@/mixins/common-mixins";
import { ContentService } from "@/service/content.service";
import { FeedbackContent } from "@/models/content/feedback";
import { CommonForm } from "@/models/common-form";
import { FeedbackFormService } from "@/service/feedback-form.service";
import { CommonFormService } from "@/service/common-form.service";
import {
  email,
  required,
  requiredIf,
  maxValue,
  numeric,
  minValue,
} from "vuelidate/lib/validators";
import { FeedbackForm, FeedbackFormExtended } from "../../models/feedback-form";

@Component({
  components: {},
  validations: {
    contactRadio: {
      required,
    },
    placedRadio: {
      required,
    },
    followupRadio: {
      required,
    },
    /*feedbackRaffleRadio: {
      required,
    },*/
    rating: {
      required,
      numeric,
      minValue: minValue(1),
      maxValue: maxValue(5),
    },
    phoneNumber: {
      required: requiredIf(function (model: Feedback): boolean {
        return model.followupRadio === true || model.feedbackRaffleRadio === true;
      }),
      validPhone(value: string): boolean {
        const regex = new RegExp(/^\d{3}-\d{3}-\d{4}$/);
        return regex.test(value);
      },
    },
    email: {
      email,
    },
    lastName: {
      required
    },
    firstName: {
      required
    }
  },
})
export default class Feedback extends Mixins(CommonMixin) {
  feedbackFormService = new FeedbackFormService();
  commonFormService = new CommonFormService();
  content = {} as FeedbackContent;
  contactRadio: boolean | null = null;
  placedRadio: boolean | null = null;
  followupRadio: boolean | null = null;

  rating: number | null = null;
  lastName = "";
  firstName = "";
  feedbackRaffleRadio: boolean | null = null;
  phoneNumber = "";
  email = "";
  additionalDetails = "";
  workflowId!: string;
  commonForm!: CommonForm;
  isSaving = false;
  isFromTextApp = false;
  feedbackForm!: FeedbackForm;
  textDirection = "ltr";

  async created(): Promise<void> {
    try {
      this.workflowId = this.$route.query.id + "";
      this.isFromTextApp = this.$route.query.d === "t";

      const commonForm = await this.commonFormService.get(this.workflowId);

      // See if feedback form has already been submitted
      const feedbackForm = await this.feedbackFormService.get(this.workflowId);
      if (feedbackForm != null && feedbackForm.rating != null) {
        this.$router.push({ path: "FeedbackResponse" });
      }
      // If the commonform with the workflowid doesn't exist, redirect to page not found.
      else if (commonForm == null) {
        this.$router.push({ path: "PageNotFound" });
      } else {
        this.phoneNumber = commonForm.caregiver?.phonenumber;
        this.email = commonForm.caregiver?.email;
        this.firstName = commonForm.caregiver?.firstname;
        this.lastName = commonForm.caregiver?.lastname;
        const postData = {} as FeedbackFormExtended;
        postData.workflowid = this.workflowId;
        postData.calledfromtextapp = this.isFromTextApp;
        this.feedbackForm = await this.feedbackFormService.create(postData);
      }
    } catch (err) {
      this.showError(`Unable to save data: ${err}`);
    }
  }
  
  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getFeedbackContent();
      this.textDirection = contentService.TextDirection();
    } 
    catch (error) {
      this.showError(error);
    }
  }

  disableSubmit(): boolean {
    return this.$v.$invalid || this.isSaving === true;
  }

  public async submit(): Promise<void> {
    try {

      if( this.disableSubmit())
        return;

      this.isSaving = true;

      let phoneNumber = "";
      let email = "";

      if (this.followupRadio === true || this.feedbackRaffleRadio === true) {
        phoneNumber = this.formatPhoneNumber10Digits(this.phoneNumber);
        email = this.email;
      }

      this.feedbackForm.contacted48 = this.contactRadio ?? false;
      this.feedbackForm.gotrecommendedprogram = this.placedRadio ?? false;
      this.feedbackForm.rating = this.rating;
      this.feedbackForm.requestfollowup = this.followupRadio ?? false;
      this.feedbackForm.anythingelse = this.additionalDetails;
      this.feedbackForm.phonenumber = phoneNumber;
      this.feedbackForm.email = email;
      this.feedbackForm.firstname = this.firstName ?? "";
      this.feedbackForm.lastname = this.lastName ?? "";
      this.feedbackForm.feedbackraffle = this.feedbackRaffleRadio ?? false;
      this.feedbackForm.feedbackdate = new Date(Date.now());

      await this.feedbackFormService.update(this.workflowId, this.feedbackForm);
      this.$router.push({ path: "FeedbackResponse" });
    } catch (err) {
      this.showError(`Unable to save data: ${err}`);
    }

    this.isSaving = false;
  }

  @Watch("phoneNumber")
  onPropertyChanged(value: string) {
    if (value != null) {
      // only allow numbers, (,), and -
      // this.phoneNumber = value.replace(/[^0-9]/g, '')
      // Once we have 10 numbers, format the number to (###) ###-####
      const numbersOnly = value.replace(/\D/g, "");
      if (numbersOnly.length == 10) {
        this.phoneNumber = numbersOnly
          .replace(/[^0-9()-]/g, "")
          .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
      }
    }
  }
}
